query SuppliersChartData {
  kpiSuppliers {
    nodes {
      title
      amount
      linkSearchValue
    }
  }
}
